function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDbu\xF0-detail",
  transform: "translate(-1190.000000, -1002.000000)",
  fill: "#88949D"
}, React.createElement("g", {
  id: "artboard.1",
  transform: "translate(1190.000000, 1002.000000)"
}, React.createElement("path", {
  d: "M18.7773438,19.25 L4.59765625,19.25 C4.33675,19.25 4.125,19.03825 4.125,18.7773438 L4.125,4.59765625 C4.125,4.33675 4.33675,4.125 4.59765625,4.125 L18.7773438,4.125 C19.03825,4.125 19.25,4.33675 19.25,4.59765625 L19.25,18.7773438 C19.25,19.03825 19.03825,19.25 18.7773438,19.25 Z M5.0703125,18.3046875 L18.3046875,18.3046875 L18.3046875,5.0703125 L5.0703125,5.0703125 L5.0703125,18.3046875 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M4.8125,2.75 C4.433,2.75 4.125,2.54466667 4.125,2.29166667 L4.125,0.458333333 C4.125,0.205333333 4.433,0 4.8125,0 C5.192,0 5.5,0.205333333 5.5,0.458333333 L5.5,2.29166667 C5.5,2.54466667 5.192,2.75 4.8125,2.75 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M4.8125,22 C4.433,22 4.125,21.7946667 4.125,21.5416667 L4.125,19.7083333 C4.125,19.4553333 4.433,19.25 4.8125,19.25 C5.192,19.25 5.5,19.4553333 5.5,19.7083333 L5.5,21.5416667 C5.5,21.7946667 5.192,22 4.8125,22 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M2.29166667,19.25 L0.458333333,19.25 C0.205333333,19.25 0,18.942 0,18.5625 C0,18.183 0.205333333,17.875 0.458333333,17.875 L2.29166667,17.875 C2.54466667,17.875 2.75,18.183 2.75,18.5625 C2.75,18.942 2.54466667,19.25 2.29166667,19.25 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M2.29166667,5.5 L0.458333333,5.5 C0.205333333,5.5 0,5.192 0,4.8125 C0,4.433 0.205333333,4.125 0.458333333,4.125 L2.29166667,4.125 C2.54466667,4.125 2.75,4.433 2.75,4.8125 C2.75,5.192 2.54466667,5.5 2.29166667,5.5 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M21.5416667,5.5 L19.7083333,5.5 C19.4553333,5.5 19.25,5.192 19.25,4.8125 C19.25,4.433 19.4553333,4.125 19.7083333,4.125 L21.5416667,4.125 C21.7946667,4.125 22,4.433 22,4.8125 C22,5.192 21.7946667,5.5 21.5416667,5.5 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M18.5625,2.75 C18.183,2.75 17.875,2.54466667 17.875,2.29166667 L17.875,0.458333333 C17.875,0.205333333 18.183,0 18.5625,0 C18.942,0 19.25,0.205333333 19.25,0.458333333 L19.25,2.29166667 C19.25,2.54466667 18.942,2.75 18.5625,2.75 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M18.5625,22 C18.183,22 17.875,21.7946667 17.875,21.5416667 L17.875,19.7083333 C17.875,19.4553333 18.183,19.25 18.5625,19.25 C18.942,19.25 19.25,19.4553333 19.25,19.7083333 L19.25,21.5416667 C19.25,21.7946667 18.942,22 18.5625,22 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M21.5416667,19.25 L19.7083333,19.25 C19.4553333,19.25 19.25,18.942 19.25,18.5625 C19.25,18.183 19.4553333,17.875 19.7083333,17.875 L21.5416667,17.875 C21.7946667,17.875 22,18.183 22,18.5625 C22,18.942 21.7946667,19.25 21.5416667,19.25 Z",
  id: "Path"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/fm2.afe3a89f.svg";
export { SvgComponent as ReactComponent };